import { isDefined } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";
import { useToast } from "@src/appV2/lib";
import { IconButton } from "@src/appV2/redesign/components/IconButton";
import { PageHeaderTopRow } from "@src/appV2/redesign/components/PageHeaderTopRow";
import { generatePath, useHistory } from "react-router-dom";

import { useGetMiscRequirement } from "../../api/wrappers/useGetMiscRequirement";
import { DOCUMENT_DETAILS_FULL_PATH, DOCUMENT_SEARCH_FULL_PATH } from "../../paths";
import { useIsWorkerRequirementsSearchEnabled } from "../../Search/useIsWorkerRequirementsSearchEnabled";

export function DocumentsPageHeaderTopRow() {
  // we use this kind of as a mutation to fetch on demand only when the button is clicked
  const { refetch: getMiscellaneousRequirement, isFetching } = useGetMiscRequirement({
    enabled: false,
  });
  const { showErrorToast } = useToast();

  const history = useHistory();

  const isWorkerRequirementsSearchEnabled = useIsWorkerRequirementsSearchEnabled();

  return (
    <PageHeaderTopRow
      rightAction={
        <Stack direction="row" spacing={2}>
          {isWorkerRequirementsSearchEnabled && (
            <IconButton
              aria-label="Search documents"
              iconType="search"
              size="medium"
              variant="outlined"
              onClick={() => {
                history.push(DOCUMENT_SEARCH_FULL_PATH);
              }}
            />
          )}
          <IconButton
            iconType="plus"
            size="medium"
            variant="outlined"
            disabled={isFetching}
            onClick={async () => {
              const { data: miscellaneousRequirement, isError } =
                await getMiscellaneousRequirement();

              if (isError || !isDefined(miscellaneousRequirement)) {
                showErrorToast(
                  "Something went wrong initiating the miscellaneous document upload. Please try again in a moment"
                );
                return;
              }

              history.push(
                generatePath(DOCUMENT_DETAILS_FULL_PATH, {
                  requirementId: miscellaneousRequirement.id,
                })
              );
            }}
          />
        </Stack>
      }
    />
  );
}
